import { GetterTree } from 'vuex';

import { CoursesStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<CoursesStateI, RootStateI> = {
};
